import React from 'react';
import { loadStoredAuth } from '../authStorage';
import ProjectPlanner from '../ProjectPlanner';

export function PlannerPage() {
  const auth = loadStoredAuth();

  return (
    <section className="planner-shell-page">
      <div className="planner-shell-header">
        <div>
          <span className="planner-shell-eyebrow">Projects</span>
          <h1 className="planner-shell-heading">Planner</h1>
          <p className="planner-shell-subheading">
            Spreadsheet planning, timeline control, and calendar visibility for multi-phase delivery work.
          </p>
        </div>
      </div>

      <div className="planner-shell-embed">
        <ProjectPlanner token={auth?.token} />
      </div>
    </section>
  );
}
